import { Picture } from '../Picture/Picture.js';
import type { PictureConfig } from '../Picture/Picture.js';

// TODO: update image URLs once CMS integration is in place
export const ACCESSORY_IMAGE_URLS: Record<string, string> = {
  ['acc-pa-001']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/1bJ0MmfinkrVh93VqwSjC8/Apple-30W-USB-C--virtalähde.png',
  ['acc-pa-002']: 'https://static.elisa.com/v2/image/2tqybbhjs47b/7dNRgMBLGOv3SrGWcd6KMa/Apple-MagSafe--laturi.png',
  ['acc-fc-001']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/6EVTizBEtf9WogM9G0nSCH/suojakotelo-Insmat-Premium-Flip-Case-Ruskea-general.png',
  ['acc-fc-002']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/1kaEe3izz1HUhGmOQf4il0/suojakotelo-Insmat-Exclusive-Flip-Case.png',
  ['acc-fc-003']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/4Ri1LG032aFFp2rFIBXYHV/Vivanco-lompakkokotelo-Musta-Yleinen.png',
  ['acc-sp-001']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/jCqLSqQnQR17Sj8OUi2GG/Insmat naytonsuojakalvo-Insmat-AntiCrash.png',
  ['acc-sp-002']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/2R8R6mowb81UECmXsjR56P/panssarilasi-Vivanco-Full-Screen-general.png',
  ['acc-case-001']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/3KNG3DBsazgwPSYYX2Ssxa/Apple-iPhone-15-Pro-Max-FineWoven-kuori-MagSafella-vihrea.png',
  ['acc-case-002']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/4pmfI1QtGMWU3H9XJQAmeS/Apple-iPhone-15-Pro-Max--takakuori-Insmat-Carbon.png',
  ['acc-case-003']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/1K2GdrHsd9t3exggUnJejx/Apple-iPhone-15-Pro-Max--suojakuori-Insmat-Impact.png',
  ['acc-ms-001']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/49q5GXl90DMnGTT0lyBWGY/Apple-iPhone-15-Pro-Max--silikonikuori-MagSafe-Guavanpinkki.png',
  ['acc-ms-002']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/ZDSLKsWiaBuB3o8njeTjO/Apple-iPhone-15-Pro-Max-kirkas-kuori-MagSafella.png',
  ['acc-ms-003']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/1fS0u41A7eYsDUcSdNCs9D/Vivanco-Mag-Steady-Apple-iPhone-15-pro-max-suojakuori-Kirkas.png',
  ['acc-ms-004']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/7wOJbfTAVQMGKSYfuhWL4L/Tech21-Evo-Clear-MagSafe-iPhone-15-Pro-Max--suojakuori.png',
  ['acc-ms-005']:
    'https://static.elisa.com/v2/image/2tqybbhjs47b/3UCakCwqsVVc3zCiP4x0fg/Tech21-Evo-Lite-iPhone-15-Pro-Max--suojakuori-Punainen.png',
};

// TODO: Replace this temporary charger image URL when Contentful integration is available.
export const CHARGER_IMAGE_URL =
  'https://elisa.fi/kauppa/static/ssr/images/product/attributes/charger_not_included.svg';

export const ACCESSORY_WIDTH_ALTERNATIVES: PictureConfig['offerWidthAlternatives'] = [80, 160, 240, 320];

interface Props {
  accessoryId: string;
  alt: string;
}

export const DeviceDetailsAccessoryPicture = ({ accessoryId, alt }: Props) => {
  const src = ACCESSORY_IMAGE_URLS[accessoryId];
  if (!src) {
    return null;
  }

  return (
    <Picture
      alt={alt}
      src={src}
      offerWidthAlternatives={ACCESSORY_WIDTH_ALTERNATIVES}
      renderedImageSize={{
        onPhone: '10rem',
        onTablet: '10rem',
        onLaptop: '10rem',
      }}
      square
      imgClasses="of-device-accessories__product-img"
    />
  );
};
